export { useForceRender } from '@openshift-console/plugin-shared/src/hooks/useForceRender';
